import { useNavigate, Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import logo from "../photo/logo.png";
import panier from "../photo/panier.png";
import login from "../photo/login.png";
import { useSelector } from "react-redux";
import { LogOut, LogIn, Menu, X, Heart, History, Settings, ClipboardList, User as UserIcon, ChevronDown, Shield } from "lucide-react";
import { UserProfileModal } from "./userProfileModal";
import "../styles/navbar.css";
import API_BASE_URL from "../config";

export function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [userDropdownOpen, setUserDropdownOpen] = useState(false);
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
    const location = useLocation();
    const listC = useSelector(s => s.listC) || [];

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get('openProfile') === 'true') {
            setUserDropdownOpen(true);
        }
    }, [location]);
    const listP = useSelector(s => s.listP) || [];
    const loggedUser = localStorage.getItem('user');
    const userObj = loggedUser ? JSON.parse(loggedUser) : null;
    const userEmail = userObj?.email || null;
    const panierItems = useSelector(s => s.panier) || [];
    const navigate = useNavigate();

    const getUniqueGenres = (list, type) => {
        if (!list || !Array.isArray(list)) return [];
        const genres = [];
        for (let i = 0; i < list.length; i++) {
            const genre = type === 'climatisseurs' ? list[i].markClimatisseur : list[i].ville;
            if (genre && !genres.includes(genre)) {
                genres.push(genre);
            }
        }
        return genres;
    };

    const handleLogout = () => {
        setShowLogoutConfirm(true);
    };

    const confirmLogoutAction = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('firebase_token');
        navigate("/login");
        setUserDropdownOpen(false);
        setShowLogoutConfirm(false);
    };

    const genresClimatisseurs = getUniqueGenres(listC, 'climatisseurs');
    const villesProjets = getUniqueGenres(listP, 'projets');

    return (
        <nav className="main-navbar">
            <div className="nav-left">
                <Link to="/" onClick={() => { setMenuOpen(false); setUserDropdownOpen(false); }}>
                    <img src={logo} alt="JL Logo" className="nav-logo" />
                </Link>
            </div>

            <div className={`nav-center ${menuOpen ? 'mobile-open' : ''}`}>
                <div className="nav-item-container">
                    <span className="nav-item-label climatiseurs">Climatiseurs</span>
                    <div className="nav-dropdown-menu">
                        {genresClimatisseurs.length > 0 ? (
                            genresClimatisseurs.map((genre, index) => (
                                <Link
                                    key={index}
                                    to={`/categorieClimatisseurs/${genre}`}
                                    className="dropdown-item"
                                    onClick={() => { setMenuOpen(false); setUserDropdownOpen(false); }}
                                >
                                    Climatiseurs {genre}
                                </Link>
                            ))
                        ) : (
                            <span className="dropdown-item">Aucun genre trouvé</span>
                        )}
                    </div>
                </div>

                <div className="nav-item-container">
                    <span className="nav-item-label projets">Projets</span>
                    <div className="nav-dropdown-menu">
                        {villesProjets.length > 0 ? (
                            villesProjets.map((ville, index) => (
                                <Link
                                    key={index}
                                    to={`/categorieProjets/${ville}`}
                                    className="dropdown-item"
                                    onClick={() => { setMenuOpen(false); setUserDropdownOpen(false); }}
                                >
                                    {ville}
                                </Link>
                            ))
                        ) : (
                            <span className="dropdown-item">Aucun projet trouvé</span>
                        )}
                    </div>
                </div>
            </div>

            <div className="nav-right">
                <Link to="/panier" className="cart-link" onClick={() => { setMenuOpen(false); setUserDropdownOpen(false); }}>
                    <img src={panier} alt="Cart" className="cart-img" />
                    {panierItems.length > 0 && (
                        <span className="cart-badge">{panierItems.length}</span>
                    )}
                </Link>

                {loggedUser ? (
                    <div className="user-profile-section">
                        {(userObj.role?.toLowerCase() === 'admin' || userObj.role?.toLowerCase() === 'super admin') ? (
                            <Link to="/dashbordPage" className="admin-direct-link" title="Dashboard Admin">
                                <Shield size={22} color="#700000" />
                                <span className="admin-nav-text">Dashboard</span>
                            </Link>
                        ) : (
                            <>
                                <button 
                                    className={`user-nav-toggle ${userDropdownOpen ? 'active' : ''}`}
                                    onClick={() => setUserDropdownOpen(true)}
                                >
                                    <div className="avatar-small-container">
                                        {userObj.profilePic ? (
                                            <img src={userObj.profilePic.replace('http://localhost:8000', API_BASE_URL.replace('/api', ''))} alt="Me" className="user-nav-avatar" />
                                        ) : (
                                            <span className="user-initial">
                                                {userObj.name ? userObj.name.charAt(0).toUpperCase() : userObj.email.charAt(0).toUpperCase()}
                                            </span>
                                        )}
                                    </div>
                                    <span className="user-nav-name">{userObj.name || userObj.email.split('@')[0]}</span>
                                    <ChevronDown size={16} className={`chevron-icon ${userDropdownOpen ? 'rotate' : ''}`} />
                                </button>

                                <UserProfileModal 
                                    isOpen={userDropdownOpen} 
                                    onClose={() => setUserDropdownOpen(false)} 
                                />
                            </>
                        )}
                    </div>
                ) : (
                    <Link to="/login" className="user-actions" title="Se connecter" onClick={() => { setMenuOpen(false); setUserDropdownOpen(false); }}>
                        <LogIn size={28} color="#000033" />
                    </Link>
                )}

                <button className="menu-toggle" onClick={() => { setMenuOpen(!menuOpen); setUserDropdownOpen(false); }}>
                    {menuOpen ? <X size={28} color="#000033" /> : <Menu size={28} color="#000033" />}
                </button>
            </div>
            {/* Custom Logout Confirmation Modal */}
            {showLogoutConfirm && (
                <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}>
                    <div style={{ background: 'white', borderRadius: '24px', padding: '36px', maxWidth: '420px', width: '90%', boxShadow: '0 20px 60px rgba(0,0,0,0.35)', border: '1px solid #eee' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '18px' }}>
                            <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'rgba(112,0,0,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <LogOut size={22} color="#700000" />
                            </div>
                            <div>
                                <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#000033', fontWeight: 800 }}>Déconnexion</h3>
                                <p style={{ margin: 0, fontSize: '0.82rem', color: '#888' }}>Vous allez fermer votre session.</p>
                            </div>
                        </div>
                        <p style={{ fontSize: '0.92rem', color: '#333', marginBottom: '28px', lineHeight: 1.6 }}>
                            Êtes-vous sûr de vouloir vous déconnecter de votre compte <strong>Jamas Lens</strong> ?
                        </p>
                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                            <button onClick={() => setShowLogoutConfirm(false)} style={{ padding: '12px 24px', borderRadius: '12px', border: '1px solid #e2e8f0', background: 'transparent', color: '#475569', cursor: 'pointer', fontWeight: 700, fontSize: '0.88rem', transition: 'all 0.2s' }} className="btn-cancel-logout">Annuler</button>
                            <button onClick={confirmLogoutAction} style={{ padding: '12px 24px', borderRadius: '12px', border: 'none', background: 'linear-gradient(135deg, #700000, #a00000)', color: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: '0.88rem', boxShadow: '0 4px 12px rgba(112,0,0,0.2)', transition: 'all 0.2s' }} className="btn-confirm-logout">Se déconnecter</button>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
}
